import { Observable } from 'rxjs/Observable'

import { BasePrompt, IBasePromptOptions } from './base-prompt'
import { ControlTypes } from '../'
import { IFormOption } from '../../services'

export interface ICheckboxOptions extends IBasePromptOptions<string> {
  options: Observable<IFormOption[]>
}

export class CheckboxPrompt extends BasePrompt<any> {
  public controlType = ControlTypes.Checkbox
  public options: Observable<IFormOption[]>

  constructor(options: ICheckboxOptions = { options: Observable.of([]) }) {
    super(options)
    this.value = options.value || []
    this.options = options.options
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/forms/models/prompt/checkbox-prompt.ts